import { styled } from 'parkdepot-shared/theme'

export const VoucherStatusContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: $theme.sizing.scale700
}))

export const SuccessIcon = styled('i', ({ $theme }) => ({
    fontSize: $theme.sizing.scale900,
    color: $theme.colors.positive700
}))

export const ErrorIcon = styled('i', ({ $theme }) => ({
    fontSize: $theme.sizing.scale900,
    color: $theme.colors.red700
}))

export const StatusText = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    margin: 0
}))
